/**
 * @generated SignedSource<<ce4aa622a15118faa8efaadde410cee4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type TeamCreateInput = {
  color: string;
  icon: TeamIcon;
  isPrivate?: boolean | null;
  name: string;
};
export type TeamCreateMutation$variables = {
  input: TeamCreateInput;
};
export type TeamCreateMutation$data = {
  readonly store: {
    readonly teamCreate: {
      readonly store: {
        readonly id: string;
        readonly publicTeams: ReadonlyArray<{
          readonly color: string | null;
          readonly icon: TeamIcon | null;
          readonly id: string;
          readonly isPrivate: boolean;
          readonly name: string;
        }>;
      };
      readonly team: {
        readonly id: string;
        readonly isPrivate: boolean;
      };
    };
  };
};
export type TeamCreateMutation = {
  response: TeamCreateMutation$data;
  variables: TeamCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "TeamCreatePayload",
        "kind": "LinkedField",
        "name": "teamCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "publicTeams",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamCreateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamCreateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3e03308869cdcfc7ff11176480397192",
    "id": null,
    "metadata": {},
    "name": "TeamCreateMutation",
    "operationKind": "mutation",
    "text": "mutation TeamCreateMutation(\n  $input: TeamCreateInput!\n) {\n  store {\n    teamCreate(input: $input) {\n      team {\n        id\n        isPrivate\n      }\n      store {\n        id\n        publicTeams {\n          id\n          name\n          color\n          icon\n          isPrivate\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "54f84b74b72d766114ac7686a3cb47fe";

export default node;
